/*global process, require*/

import "core-js/stable"
import "regenerator-runtime/runtime"
import ReactRailsUJS from "react_ujs"
import Rails from "@rails/ujs"
import Turbolinks from "turbolinks"
import * as $ from "jquery"

if (process.env.NODE_ENV === "development") {
  require("preact/debug")
} else if (process.env.NODE_ENV === "production") {
  require("app/scripts/public_path")
}

import {
  newrelicSetup,
  oneTimeSetup,
  sharedSetup,
} from "app/scripts/shared_setup"
import RubberBandPinchColor from "app/scripts/rubber_band_pinch_color"
import BackButton from "app/scripts/back_button"

// Add assets to the manifest:
require.context("images", true)
require.context("fonts", true)

newrelicSetup()
oneTimeSetup()
$(document).on("turbolinks:load", sharedSetup)

Rails.start()
// from https://github.com/reactjs/react-rails#event-handling
// Order is particular. First start Turbolinks:
Turbolinks.start()
// Add Turbolinks to the global namespace:
window.Turbolinks = Turbolinks
// Remove previous event handlers and add new ones:
ReactRailsUJS.detectEvents()

window.App = window.App || {}
window.App.Comps = {}
window.App.Scripts = {
  RubberBandPinchColor,
  BackButton,
}
